import React, { useEffect, useMemo, useState } from 'react';
import dayjs, { getDefaultFormat, time2utc } from '../_util/day';
import Button from '../button';
import DatePicker from '../date-picker';
import Day from '../day';
import Explain from '../explain';
import { useConfig } from '../hooks/useConfig';
import { getTransedText } from '../locale';
import Space from '../space';
import { CUSTOMKEY } from './interface';
import { defaultFullMinute, compareTimes, getDefaultValue, checkAllowableTimeSpan } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CustomDateContent = _ref => {
  let {
    onApply,
    timeZone,
    value,
    earliestTime,
    latestTime,
    allowableTimeSpan,
    fullMinute
  } = _ref;
  const {
    locale: {
      PresetDatePicker: PresetDatePickerLocale
    }
  } = useConfig();
  const defaultDate = useMemo(() => {
    return getDefaultValue(value, {
      timeZone,
      earliestTime,
      latestTime,
      fullMinute
    });
  }, []);
  const [startTime, setStartTime] = useState(defaultDate.startTime);
  const [endTime, setEndTime] = useState(defaultDate.endTime);
  const [error, setError] = useState();
  useEffect(() => {
    const startError = !!earliestTime && dayjs(startTime).isBefore(dayjs(earliestTime)) && getTransedText(PresetDatePickerLocale.startTimeError, {
      earliestTime: dayjs(earliestTime).tz(timeZone).format(getDefaultFormat())
    });
    const endError = !!latestTime && dayjs(endTime).isAfter(dayjs(latestTime)) && getTransedText(PresetDatePickerLocale.endTimeError, {
      latestTime: dayjs(latestTime).tz(timeZone).format(getDefaultFormat())
    });
    const rangeError = !!allowableTimeSpan && !checkAllowableTimeSpan({
      startTime,
      endTime,
      allowableTimeSpan
    }) && /*#__PURE__*/_jsxs("span", {
      children: [PresetDatePickerLocale.rangeError, /*#__PURE__*/_jsx(Day.IntervalTiming, {
        timeSpan: allowableTimeSpan,
        canShowMonth: false
      })]
    });
    setError({
      startError,
      endError,
      rangeError
    });
  }, [startTime, endTime]);
  return /*#__PURE__*/_jsxs(Space, {
    direction: "vertical",
    align: "end",
    itemWidth: {
      0: '100%',
      2: '100%'
    },
    block: true,
    children: [/*#__PURE__*/_jsx("div", {
      children: PresetDatePickerLocale.label_from
    }), /*#__PURE__*/_jsx(Explain, {
      helperText: error === null || error === void 0 ? void 0 : error.startError,
      children: /*#__PURE__*/_jsx(DatePicker, {
        showTime: {
          minuteStep: defaultFullMinute,
          format: 'HH:mm'
        },
        format: () => dayjs(startTime).tz(timeZone).format(getDefaultFormat()),
        width: 308,
        size: "s",
        type: "filled",
        showNow: false,
        value: dayjs(startTime).tz(timeZone),
        onChange: d => {
          const [start, end] = compareTimes(time2utc(d.tz(dayjs.tz.guess())), endTime);
          setStartTime(start);
          setEndTime(end);
        }
      })
    }), /*#__PURE__*/_jsx("div", {
      children: PresetDatePickerLocale.label_to
    }), /*#__PURE__*/_jsx(Explain, {
      helperText: (error === null || error === void 0 ? void 0 : error.endError) || (error === null || error === void 0 ? void 0 : error.rangeError),
      children: /*#__PURE__*/_jsx(DatePicker, {
        showTime: {
          minuteStep: 5,
          format: 'HH:mm'
        },
        format: d => dayjs(endTime).tz(timeZone).format(getDefaultFormat()),
        width: 308,
        size: "s",
        type: "filled",
        showNow: false,
        value: dayjs(endTime).tz(timeZone),
        onChange: d => {
          const [start, end] = compareTimes(startTime, time2utc(d.tz(dayjs.tz.guess())));
          setStartTime(start);
          setEndTime(end);
        }
      })
    }), /*#__PURE__*/_jsx(Button, {
      size: "s",
      disabled: !endTime || !startTime || !!(error !== null && error !== void 0 && error.startError) || !!(error !== null && error !== void 0 && error.endError) || !!(error !== null && error !== void 0 && error.rangeError),
      onClick: () => {
        onApply({
          datePreset: CUSTOMKEY,
          startTime,
          endTime
        });
      },
      children: PresetDatePickerLocale.button_apply
    })]
  });
};
export default CustomDateContent;